import { inject, Injectable } from '@angular/core';
import { RedirectCommand, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { PosthogService } from './posthog.service';

@Injectable({ providedIn: 'root' })
export class AccountGuard {
  private authService = inject(AuthService);
  private _router = inject(Router);
  private _posthogService = inject(PosthogService);

  canActivate(): boolean | RedirectCommand {
    if (!this.authService.connecting) {
      this._posthogService.captureEvent('redirect /login', { source: 'service', from: 'account-guard' });
      const loginPath = this._router.parseUrl('/login');
      return new RedirectCommand(loginPath);
    }
    return true;
  }
}
